<template>
  <v-alert :type="options.type" :value="options.visible" tile :dense="true">
    {{ options.text }}
  </v-alert>
</template>

<script>
export default {
  props: ["options"]
}
</script>
